/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceTabletPlus = createReactComponent(
  "device-tablet-plus",
  "IconDeviceTabletPlus",
  [
    [
      "path",
      {
        d: "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8",
        key: "svg-0"
      }
    ],
    ["path", { d: "M16 19h6", key: "svg-1" }],
    ["path", { d: "M19 16v6", key: "svg-2" }],
    ["path", { d: "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-3" }]
  ]
);

export { IconDeviceTabletPlus as default };
//# sourceMappingURL=IconDeviceTabletPlus.js.map
